export const CREATE_EDIT_PROFILE_REQUEST = 'CREATE_EDIT_PROFILE_REQUEST'
export const CREATE_EDIT_PROFILE_REQUEST_PENDING = 'CREATE_EDIT_PROFILE_REQUEST_PENDING'
export const CREATE_EDIT_PROFILE_REQUEST_FULFILLED = 'CREATE_EDIT_PROFILE_REQUEST_FULFILLED'
export const CREATE_EDIT_PROFILE_REQUEST_REJECTED = 'CREATE_EDIT_PROFILE_REQUEST_REJECTED'
